module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-row list-item flow-list-item",
    class: {
      clickable: !_vm.is_processing
    },
    on: {
      "click": function($event) {
        return _vm.rowClicked($event)
      }
    }
  }, [_c('div', {
    staticClass: "table-col table-col-collapsed-half"
  }, [_c('div', {
    class: _vm.circleStatusClass()
  })]), _c('div', {
    staticClass: "table-col table-col-300 overflow-hidden"
  }, [_c('div', {
    staticClass: "flow-name overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.flow.name))]), _c('div', {
    staticClass: "flow-details"
  }, [_c('div', {
    staticClass: "flow-actions-count"
  }, [_vm._v(_vm._s(_vm.flow.actions_count) + " " + _vm._s(_vm.$t('general.label.actions')))]), _c('div', {
    staticClass: "flow-days-count"
  }, [_vm._v(" " + _vm._s(_vm.flow.duration_in_days) + " " + _vm._s(_vm.$t('general.label.days')))])])]), (_vm.flow.hasStatusMessage()) ? _c('div', {
    staticClass: "table-col table-col-300 message-status-table-col"
  }, [_c('div', {
    class: _vm.flow_status_message_class
  }, [_vm._v(_vm._s(_vm.flow_status_message))])]) : [(_vm.default_options.show_contacts_count) ? _c('div', {
    staticClass: "table-col"
  }, [_c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "percentage"
  }, [_vm._v(_vm._s(_vm.flow.contacts_count()))]), _c('div', {
    staticClass: "legend"
  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.contacts')))])])]) : _vm._e(), _c('div', {
    staticClass: "table-col"
  }, [_c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.flow.recipients_statistics_conversion()))]), _c('div', {
    staticClass: "legend"
  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.conversion')))])])]), (_vm.default_options.show_reply_statistic) ? _c('div', {
    staticClass: "table-col"
  }, [_c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.flow.email_statistic.replyPercentage(_vm.flow.recipients_count)))]), _c('div', {
    staticClass: "legend"
  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.reply')))])])]) : _vm._e()], (_vm.default_options.show_user) ? _c('div', {
    staticClass: "table-col table-col-150"
  }, [_c('user-miniature', {
    attrs: {
      "user": _vm.flow.user
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [(_vm.default_options.action == 'dropdown' && (!_vm.is_processing || _vm.current_user.isAdmin())) ? _c('div', {
    staticClass: "action clickable-element"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_vm._m(0), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.viewFlow
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.toView')))])]), (!_vm.current_user.isMonitoringManager()) ? _c('li', [_c('a', {
    on: {
      "click": _vm.editFlow
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.edit')))])]) : _vm._e(), _vm._l((_vm.flow.next_valid_statuses), function(next_status_options, next_status) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.updateFlow({
            status: next_status
          })
        }
      }
    }, [_c('a', [_vm._v(_vm._s(next_status_options.human_action_name))])])
  }), (!_vm.current_user.isMonitoringManager()) ? _c('li', [_c('a', {
    on: {
      "click": _vm.openDestroyFlowConfirmationModal
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.delete')))])]) : _vm._e()], 2)])]) : (_vm.default_options.action == "select") ? _c('div', {
    staticClass: "action"
  }, [_vm._m(1)]) : _vm._e()])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-menu-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn select-action"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-menu-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47a20bae!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/flows/list_item.vue
// module id = 1099
// module chunks = 1